import { NOTIFICATION_TYPE_ENUM } from "interfaces";
import { observer } from "mobx-react-lite";
import { useNotificationContext } from "providers";
import { useState } from "react";
import { getCollectQuote } from "services";
import { useStores } from "stores";
import { CustomButton } from "ui";
import { parseErrorMessage } from "utils";

export const GetCollectQuoteButton = observer(() => {
  const { openNotification } = useNotificationContext();
  const [isLoading, setIsLoading] = useState(false);
  const { bidCard } = useStores();

  const getCollectQuoteHandler = async () => {
    setIsLoading(true);
    await getCollectQuote({ id: bidCard.bid.id })
      .then(() => {
        openNotification({
          message: "Начат сбор котировок",
          type: NOTIFICATION_TYPE_ENUM.SUCCESS,
        });
      })
      .catch((error) => {
        openNotification({
          message: "Ошибка при сборе котировок",
          description: parseErrorMessage(error),
          type: NOTIFICATION_TYPE_ENUM.ERROR,
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <CustomButton onClick={() => getCollectQuoteHandler()} loading={isLoading} disabled={isLoading}>
      Запросить котировки
    </CustomButton>
  );
});
